import { render, staticRenderFns } from "./YesNot.vue?vue&type=template&id=cafc444e"
import script from "./YesNot.vue?vue&type=script&lang=js"
export * from "./YesNot.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../frontAgencies/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports